export default __webpack_public_path__ + "static/angle-d6bd0fbd2c19a6ea2c3fc1b921594753.png";